
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_2","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 32 32","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M30.4 8.4c-.1-.2-.3-.3-.6-.3h-5.4c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h4.4l-3.4 12.1H10.9l-3-12.1h4.5c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7H7.5L6.1 2.7c-.1-.3-.4-.6-.7-.6H2.2c-.4 0-.7.3-.7.7s.3.7.7.7h2.7l4.7 19c.1.3.4.5.7.5H26c.3 0 .6-.2.7-.5L30.5 9c.1-.2 0-.4-.1-.6zM11.9 24.4c-1.6 0-2.9 1.3-2.9 2.9 0 1.6 1.3 2.9 2.9 2.9s2.9-1.3 2.9-2.9c0-1.6-1.3-2.9-2.9-2.9zm0 4.3c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5c0 .9-.7 1.5-1.5 1.5zM23.9 24.4c-1.6 0-2.9 1.3-2.9 2.9 0 1.6 1.3 2.9 2.9 2.9 1.6 0 2.9-1.3 2.9-2.9 0-1.6-1.3-2.9-2.9-2.9zm0 4.3c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5c-.1.9-.7 1.5-1.5 1.5z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M18.1 13.2c2.6 0 4.8-2.1 4.8-4.8s-2.1-4.8-4.8-4.8-4.8 2.1-4.8 4.8 2.2 4.8 4.8 4.8zm0-8.2c1.9 0 3.4 1.5 3.4 3.4s-1.5 3.4-3.4 3.4-3.4-1.5-3.4-3.4S16.3 5 18.1 5z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M16 10.3c.1.2.3.2.5.2s.3-.1.5-.2l1.1-1 1.1 1c.1.1.3.2.5.2s.4-.1.5-.2c.3-.3.2-.7-.1-1l-1-.9 1-.9c.3-.3.3-.7.1-1-.3-.3-.7-.3-1-.1l-1.1 1-1.1-1c-.3-.3-.7-.2-1 .1-.3.3-.2.7.1 1l1 .9-1 .9c-.3.2-.3.7-.1 1z"}})])
          )
        }
      }
    